import React, { memo } from "react";
import {
  fmt,
  getByPath,
  toneFor,
} from "../../utils/results/metricsKVTableHelpers";
import { useTranslation } from "react-i18next";

function MetricsKVTable({ record = {}, className = "", fields }) {
  const { t } = useTranslation();

  const FIELDS = fields;

  return (
    <div
      className={`w-full border border-greyscale-1 rounded-lg overflow-hidden ${className}`}
    >
      <div className="grid grid-cols-2 border-t border-greyscale-1 first:border-t-0 bg-greyscale-1 ">
        <div className="p-2 px-3 border-r border-greyscale-1">
          <p className="leading-snug">
            {t("results.field", { defaultValue: "Field" })}
          </p>
        </div>
        <div className="p-2 px-3">
          <p>{t("results.value", { defaultValue: "Value" })}</p>
        </div>
      </div>

      {FIELDS.map((f, idx) => {
        const raw = getByPath(record, f.path);
        const value =
          typeof f.fmt === "function"
            ? f.fmt(raw, record)
            : (fmt[f.fmt || "text"] || fmt.text)(raw, f.path);

        const renderedLabel = f.i18nKey
          ? t(f.i18nKey, { defaultValue: f.label })
          : f.label;

        return (
          <div
            key={`${f.label}-${idx}`}
            className="grid grid-cols-2 border-t border-greyscale-1 first:border-t-0"
          >
            <div className="p-2 px-3 border-r border-greyscale-1">
              <p>{renderedLabel}</p>
            </div>
            <div className="p-2 px-3">
              <p className={`${toneFor(f.label, value)}`}>{value}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default memo(MetricsKVTable);
